import axios from "axios";
import { BASE_URL } from "../../Utlils";

// get the survey count by statuses
export const getSurveyCount = async (id) => {
  try {
    const { data } = await axios.get(`${BASE_URL}/survey/${id}/survey-counts`);
    return data;
  } catch (error) {
    console.log("Unable to get survey count by status");
    throw error;
  }
};
// archive the surveys
export const archiveSurvey = async (selectRows) => {
  try {
    const requests = selectRows.map((row) =>
      axios.put(`${BASE_URL}/survey?id=${row?._id}`, {
        surveyStatus: "archived",
      })
    );
    const responses = await Promise.all(requests);
    return responses.map((response) => response.data);
  } catch (error) {
    console.log("Unable to archive survey");
    throw error;
  }
};
// add new survey
export const addNewSurvey = async (inputData, user) => {
  try {
    if (
      !Object.keys(inputData || {})?.length &&
      !Object.keys(inputData || {})?.length
    ) {
      throw new Error("Missing Required fields");
    }
    const B2CQuestions = [
      {
        question: "656d6d54f1cdf363aab57950",
        validOptions: [
          { from: 18, to: inputData?.setup?.targetAudience == "B2C" ? 75 : 60 },
        ],
        displayOptions: [],
        status: true,
      },
      {
        question: "656d6d54f1cdf363aab57954",
        validOptions: ["Male", "Female"],
        displayOptions: ["Male", "Female", "others"],
        status: true,
        condition: {
          min: "",
          max: "",
        },
      },
    ];
    const B2BQuestions = {
      question: "656d6d55f1cdf363aab579c0",
      validOptions: [
        "Employed full-time",
        "Employed part-time",
        "Self-employed full-time",
        "Self-employed part-time",
        "Active military",
        "Inactive military/Veteran",
        "Temporarily unemployed",
        "Full-time homemaker",
        "Retired",
        "Student",
        "Disabled",
        "Prefer not to answer",
      ],
      displayOptions: [
        "Employed full-time",
        "Employed part-time",
        "Self-employed full-time",
        "Self-employed part-time",
        "Active military",
        "Inactive military/Veteran",
        "Temporarily unemployed",
        "Full-time homemaker",
        "Retired",
        "Student",
        "Disabled",
        "Prefer not to answer",
      ],
      status: true,
      condition: {
        min: "",
        max: "",
      },
    };
    // Prepare survey payload
    const surveyPayload = {
      ...inputData,
      setup: {
        ...inputData?.setup,
        businessUnit: user?.organizationName,
      },
      createdBy: user?.organizationId,
      qualification:
        inputData?.setup?.targetAudience == "B2C"
          ? B2CQuestions
          : [...B2CQuestions, B2BQuestions],
    };

    // Add Instant Sampling fields if enabled (check !== false since undefined defaults to true)
    if (inputData?.isInstantSampling !== false) {
      surveyPayload.DIY_SurveyType = 1;
      surveyPayload.priority = 2;
      // Check if [INT] is already present in organization name
      const orgName = user?.organizationName || "";
      const lucidClientName = orgName.startsWith("[INT]") 
        ? orgName 
        : `[INT] ${orgName}`;
      surveyPayload.lucidClientName = lucidClientName;
      surveyPayload.lucidCompletePercentage = 0;
      surveyPayload.lucidConversion = 0;
      surveyPayload.lucidMobileConversion = 0;
      surveyPayload.lucidOverallCompletes = 0;
      surveyPayload.lucidRespondentPids = [];
      surveyPayload.lucidSurveyGroupIds = [];
      surveyPayload.lucidTermination_LOI = 0;
      surveyPayload.lucidTotalClientEntrants = 0;
      // // Auto-set status to "live" for instant mode surveys
      // surveyPayload.surveyStatus = "live";
    }

    // Remove isInstantSampling from payload as it's not part of the model
    delete surveyPayload.isInstantSampling;

    let res = await axios.post(`${BASE_URL}/survey`, surveyPayload);
    if (inputData?.surveyGroup) {
      await axios.put(
        `${BASE_URL}/survey-group/add-survey?sid=${res?.data?._id}&sgId=${inputData?.surveyGroup}`
      );
    }
    return res.data;
  } catch (error) {
    console.log("Unable to add new survey");
    throw error;
  }
};
export const editSurveyAction = async (inputData) => {
  try {
    if (!Object.keys(inputData || {}).length) {
      throw new Error("Missing Required fields");
    }

    // Prepare update payload
    const updatePayload = { ...inputData };

    // Handle Instant Sampling for edits
    if (updatePayload?.isInstantSampling) {
      updatePayload.DIY_SurveyType = 1;
      updatePayload.priority = 2;
      // Use existing lucidClientName if available, otherwise check businessUnit or set with [INT] prefix
      if (!updatePayload.lucidClientName) {
        const businessUnit = updatePayload?.setup?.businessUnit || "";
        updatePayload.lucidClientName = businessUnit.startsWith("[INT]") 
          ? businessUnit 
          : `[INT] ${businessUnit}`;
      }
      // Initialize Lucid tracking fields if they don't exist
      if (updatePayload.lucidCompletePercentage === undefined) updatePayload.lucidCompletePercentage = 0;
      if (updatePayload.lucidConversion === undefined) updatePayload.lucidConversion = 0;
      if (updatePayload.lucidMobileConversion === undefined) updatePayload.lucidMobileConversion = 0;
      if (updatePayload.lucidOverallCompletes === undefined) updatePayload.lucidOverallCompletes = 0;
      if (!updatePayload.lucidRespondentPids) updatePayload.lucidRespondentPids = [];
      if (!updatePayload.lucidSurveyGroupIds) updatePayload.lucidSurveyGroupIds = [];
      if (updatePayload.lucidTermination_LOI === undefined) updatePayload.lucidTermination_LOI = 0;
      if (updatePayload.lucidTotalClientEntrants === undefined) updatePayload.lucidTotalClientEntrants = 0;
      // Auto-set status to "live" when enabling Instant Sampling (if not already live)
      if (updatePayload.surveyStatus !== "live") {
        updatePayload.surveyStatus = "live";
      }
    } else if (updatePayload?.isInstantSampling === false && updatePayload?.DIY_SurveyType === 1) {
      // If unchecking Instant Sampling, set fields to null to remove them
      // Note: We don't change the status back - leave it as-is
      updatePayload.DIY_SurveyType = null;
      updatePayload.priority = null;
      updatePayload.lucidClientName = null;
    }

    // Remove isInstantSampling from payload as it's not part of the model
    delete updatePayload.isInstantSampling;

    const requests = [
      axios.put(`${BASE_URL}/survey?id=${inputData._id}`, updatePayload),
    ];

    if (
      inputData.prevSurveyGroup &&
      inputData.prevSurveyGroup !== inputData.surveyGroup
    ) {
      requests.push(
        axios.put(
          `${BASE_URL}/survey-group/remove-survey-and-add-new?oSgId=${inputData.prevSurveyGroup}&newSgId=${inputData.surveyGroup}&sid=${inputData._id}`
        )
      );
    }

    const [res] = await Promise.all(requests);
    return res.data;
  } catch (error) {
    console.log("Unable to edit  survey");
    throw error;
  }
};
export const getAllSurveyStats = async (
  id,
  reset,
  tab,
  page,
  rows,
  industry,
  projectManager,
  studyType,
  country,
  searchText
) => {
  try {
    let data = await axios(
      `${BASE_URL}/session/survey-sessions?organization=${id}&reset=${reset}&status=${tab}&page=${
        Number(page) + 1
      }&rows=${rows}&industry=${industry}&projectManager=${projectManager}&studyType=${studyType}&country=${country}&searchText=${searchText}`
    );
    let newData = data.data;
    return newData;
  } catch (error) {
    // console.log(error);
    console.log("something went wrong while fetching the survey stats");
    throw error;
  }
};

// ==========================================
// AI Survey Creation Actions
// ==========================================

/**
 * Get AI usage status for an organization
 * @param {string} orgId - Organization ID
 * @returns {Promise<{count: number, limit: number, remaining: number}>}
 */
export const getAIUsageStatus = async (orgId) => {
  try {
    const { data } = await axios.get(`${BASE_URL}/survey/ai-usage/${orgId}`);
    return data.data;
  } catch (error) {
    console.log("Unable to get AI usage status");
    throw error;
  }
};

/**
 * Generate survey configuration from RFP using AI
 * @param {string} rfpText - The RFP text content
 * @param {string} orgId - Organization ID
 * @returns {Promise<{surveys: Array, isMultiCountry: boolean, suggestedGroupName: string, remainingToday: number}>}
 */
export const generateAISurvey = async (rfpText, orgId) => {
  try {
    const { data } = await axios.post(`${BASE_URL}/survey/ai-generate`, {
      rfpText,
      orgId,
    });
    return data.data;
  } catch (error) {
    console.log("Unable to generate AI survey");
    throw error;
  }
};

/**
 * Create surveys from AI-generated configurations
 * @param {Array} surveys - Array of survey configurations
 * @param {string} orgId - Organization ID
 * @param {string} userId - User ID
 * @param {string} organizationName - Organization name
 * @param {string} projectManagerId - Project Manager user ID
 * @param {boolean} createGroup - Whether to create a survey group
 * @param {string} groupName - Name for the survey group
 * @returns {Promise<{surveys: Array, surveyGroupId: string|null, createdCount: number, remainingToday: number}>}
 */
export const createAISurveys = async (
  surveys,
  orgId,
  userId,
  organizationName,
  projectManagerId,
  createGroup = false,
  groupName = ""
) => {
  try {
    const { data } = await axios.post(`${BASE_URL}/survey/ai-create`, {
      surveys,
      orgId,
      userId,
      organizationName,
      projectManagerId,
      createGroup,
      groupName,
    });
    return data.data;
  } catch (error) {
    console.log("Unable to create AI surveys");
    throw error;
  }
};

/**
 * Generate AI qualification drafts for user review
 * @param {string} surveyId - Survey ID
 * @param {string} objective - Objective text used for generation
 * @returns {Promise<{drafts:Array,objective:string,totalCandidates:number}>}
 */
export const generateAIQualificationDrafts = async (surveyId, objective) => {
  try {
    const { data } = await axios.post(
      `${BASE_URL}/survey/${surveyId}/qualification-ai-generate`,
      {
        objective,
      }
    );
    return data?.data;
  } catch (error) {
    console.log("Unable to generate AI qualification drafts");
    throw error;
  }
};

/**
 * Apply user-approved AI qualification drafts
 * @param {string} surveyId - Survey ID
 * @param {string} objective - Objective text used for generation
 * @param {Array} approvedDrafts - Selected and edited drafts
 * @returns {Promise<{addedQualifications:number,createdQuestions:number,reusedQuestions:number}>}
 */
export const convertSessionsToComplete = async ({ surveyId, sessionIds }) => {
  try {
    const { data } = await axios.post(
      `${BASE_URL}/survey/${surveyId}/sessions/convert-to-complete`,
      { sessionIds }
    );
    return data;
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.message ||
      "Unable to convert sessions";
    throw new Error(message);
  }
};

export const applyAIQualifications = async (surveyId, objective, approvedDrafts) => {
  try {
    const { data } = await axios.post(
      `${BASE_URL}/survey/${surveyId}/qualification-ai-apply`,
      {
        objective,
        approvedDrafts,
      }
    );
    return data?.data;
  } catch (error) {
    console.log("Unable to apply AI qualifications");
    throw error;
  }
};
